import { Build } from '@todesktop/shared';
import BuildPicker from '../../components/BuildPicker';
import ErrorBoundary from '../../components/ErrorBoundary';
import LoginHOC from '../../components/LoginHOC';
import { useAnalyticsCommand } from '../../utilities/useAnalytics';
import ReleaseBuildLogic from './components/ReleaseBuildLogic';
import ReleaseConfirmation from './components/ReleaseConfirmation';
import analyzeRelease from './utilities/analyzeRelease';

export default function ReleaseCommand({
  buildId,
  configPath,
  shouldConfirm,
}: {
  buildId: string;
  configPath?: string;
  shouldConfirm: boolean;
}) {
  useAnalyticsCommand('release', {
    buildId,
    shouldConfirm,
    config: configPath,
  });

  let command = 'todesktop release';
  if (buildId) {
    command += ' ' + (buildId === 'latest' ? '--latest' : '<id>');
  }

  return (
    <ErrorBoundary>
      <LoginHOC>
        <BuildPicker
          buildFilter={isBuildReleasable}
          buildId={buildId}
          commandUsed={command}
          configPath={configPath}
          noBuildsDescription="(i.e. unreleased and successful)"
          question="Which build would you like to release?"
        >
          {(id) => (
            <ReleaseConfirmation
              buildId={id}
              configPath={configPath}
              disabled={!shouldConfirm}
            >
              <ReleaseBuildLogic
                buildId={id}
                commandUsed={command}
                configPath={configPath}
              />
            </ReleaseConfirmation>
          )}
        </BuildPicker>
      </LoginHOC>
    </ErrorBoundary>
  );
}

function isBuildReleasable(opts: {
  build: Build;
  latestReleasedBuild?: Build;
}) {
  return analyzeRelease(opts).isReleasable;
}
